import snakecaseKeys from 'snakecase-keys';

import { SexEnum } from '@uplift/types';

import { restClient } from '../../client';
import { Address, User, UserPrefix, UserProfile, UserSuffix } from '../../resources';

export type GetUserResponse = { data: User };

export const getUser = async (userId: string) =>
  restClient.request<PatchUserResponse>(`/api/v1/user/${userId}`);

export type PatchUserInput = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
};
export type PatchUserResponse = { data: User };

export const patchUser = async (userId: string, data: PatchUserInput) =>
  restClient.request<PatchUserResponse>(
    `/api/v1/user/${userId}`,
    {
      method: 'PATCH',
      data: snakecaseKeys(data)
    }
  );


export const getUserProfile = async (userId: string) =>
  restClient.request<{ data: UserProfile }>(`/api/v1/user/${userId}/profile`);


export type PatchUserProfileInput = Partial<{
  preferredName: string;
  dateOfBirth: string;
  pronouns: string;
  shortBio: string;
  sex: SexEnum;
  address: Address;
  prefix: UserPrefix | null;
  suffixes: UserSuffix[] | null;
  timezone: string;
  receiveTherapyBy: string;
  title: string;

  avatarAssetId: string;
  avatarAssetIdToUpdate: string;
  originalAvatarAssetId: string;
  originalAvatarAssetIdToUpdate: string;
}>;

export type PatchUserProfileResponse = { data: UserProfile };

export const patchUserProfile = async (userId: string, data: PatchUserProfileInput) =>
  restClient.request<PatchUserProfileResponse>(
    `/api/v1/user/${userId}/profile`,
    {
      method: 'PATCH',
      data: snakecaseKeys(data)
    }
  );

export const getAvailableSuffixes = async () => {
  return restClient.request<{ data: UserSuffix[] }>('/api/v1/user/suffixes', { method: 'GET' });
};
